class Modal {
  constructor(modalID, useControls = true) {
    this.props = {
      elem: modalID,
      controls: '.c-modal-controls',
      show: 'is-show',
      hide: 'is-hide',
      details: 'is-details',
      clip: '.modal__clip',
      btnClose: '.modal__btn-close',
      btnClip: '.btn-clip',
      btnClipClose: '.btn-clip-close',
      useControls: useControls
    }

    if (this.props.useControls) {
      this.onControls();
    }

    this.onCloseButtons();
    document.addEventListener('keyup', this.onKeys.bind(this));

    if (document.querySelector(this.props.btnClip)) {
      document.querySelector(this.props.btnClip).addEventListener('click', this.openDetails.bind(this));
      document.querySelector(this.props.btnClipClose).addEventListener('click', this.closeDetails.bind(this));
    }
  }

  openModal() {
    if (document.querySelector(this.props.elem).classList.contains(this.props.hide)) {
      document.querySelector(this.props.elem).classList.remove(this.props.hide);
    }

    document.querySelector(this.props.elem).classList.add(this.props.show);
  }

  openDetails() {
    document.querySelector(this.props.elem).classList.add(this.props.details);
    document.querySelector(this.props.clip).classList.add(this.props.show);
    player.pauseVideo();
  }

  closeModal() {
    document.querySelector(this.props.elem).classList.add(this.props.hide);
    document.querySelector(this.props.elem).classList.remove(this.props.details);

    // if has video player
    if (document.body.contains(document.getElementById('player'))) player.stopVideo();

    if (document.body.contains(document.getElementById('player-tourvirtual'))) {
      // player.stopVideo();
      setTimeout(function () {
        document.getElementById('player-tourvirtual').innerHTML = '';
      }, 250);
    }

    // if has details
    if (document.querySelector(this.props.btnClip)) {
      document.querySelector(this.props.clip).classList.remove(this.props.show);
    }
  }

  closeDetails() {
    document.querySelector(this.props.clip).classList.remove(this.props.show);
    document.querySelector(this.props.elem).classList.remove(this.props.details);
    player.playVideo();
  }

  onControls() {
    if (!this.props.useControls) {
      return document.querySelector(this.props.controls).classList.add(this.props.hide);
    }

    document.querySelector(this.props.controls).classList.remove(this.props.hide);

    // if has video player
    document.querySelector(this.props.controls).addEventListener('click', () => {
      if (player && document.getElementById('player')) player.pauseVideo();
    });
  }

  onCloseButtons() {
    Array.prototype.slice
      .call(document.querySelectorAll(this.props.btnClose))
      .map(item => item.addEventListener('click', () => this.closeModal()));
  }

  onKeys(evt) {
    const key = evt.key || evt.keyCode;

    if (evt.defaultPrevented) {
      return;
    }

    if (key === 'Escape' || key === 'Esc' || key === 27) {
      this.closeModal();
    }
  }
}

export default Modal;